/** @flow */
import React from "react";
import classNames from "classnames";
import { Button } from "@components";

type ButtonGroupProps = $Exact<{
  fillSpace?: boolean,
  className?: string,
  config?: [{ label: string, color?: string, onClick: Function }],
  children?: React$Node,
  disabled?: boolean,
}>;

export function ButtonGroup({
  fillSpace,
  disabled,
  className,
  children,
  config,
}: ButtonGroupProps) {
  return (
    <div
      className={classNames(
        "button-group",
        {
          "fill-space": fillSpace,
          disabled: disabled,
        },
        className,
      )}
    >
      {(config &&
        config.map(btn => (
          <Button key={btn.label} color={btn.color} onClick={btn.onClick}>
            {btn.label}
          </Button>
        ))) ||
        children}
    </div>
  );
}
